<template>
  <div class="bz-modal-scrim" @click="$emit('decline')">
    <div class="bz-modal" role="dialog" aria-modal="true" @click.stop>
      <div class="bz-modal-h">
        <span class="bz-modal-icn"><i class="material-icons" style="font-size:20px;line-height:1;">{{ cfg.icon }}</i></span>
        <div>
          <h2>Add the matching {{ cfg.name }}?</h2>
          <p class="bz-modal-sub">Your report is ready. You can also add {{ cfg.name }} ({{ cfg.blurb }}) for this exact selection — everything carries over, nothing else to choose.</p>
        </div>
        <button class="bz-upsell-x" type="button" title="Dismiss" @click="$emit('decline')">
          <i class="material-icons" style="font-size:17px;line-height:1;">close</i>
        </button>
      </div>
      <div class="bz-carry">
        <div class="bz-carry-row">
          <i class="material-icons" style="font-size:15px;line-height:1;color:var(--bzc-good);">check</i>
          <span class="bz-carry-k">Industry</span><b>{{ industry.name }}</b><code class="bz-code">{{ industry.code }}</code>
        </div>
        <div class="bz-carry-row">
          <i class="material-icons" style="font-size:15px;line-height:1;color:var(--bzc-good);">check</i>
          <span class="bz-carry-k">Market Area</span><b>{{ area.label }}</b><span class="bz-carry-note">carried over</span>
        </div>
        <div v-if="toIFP && sc" class="bz-carry-row">
          <i class="material-icons" style="font-size:15px;line-height:1;color:var(--bzc-good);">check</i>
          <span class="bz-carry-k">Sales Class</span><b>{{ scLabel }}</b><span class="bz-carry-note">carried over</span>
        </div>
        <div v-if="toIFP" class="bz-carry-row">
          <i class="material-icons" style="font-size:15px;line-height:1;color:var(--bzc-faint);">tune</i>
          <span class="bz-carry-k">Defaults</span>
          <span class="bz-carry-note">{{ structure === 'sole_proprietorship' ? 'Sole Proprietorship' : 'Industry Firms' }} · {{ timeline === '3yr' ? '3 Years Profile' : '5 Years Profile' }}</span>
        </div>
      </div>
      <div class="bz-modal-foot">
        <button class="bz-btn ghost" type="button" @click="$emit('decline')">No thanks — continue</button>
        <button class="bz-btn primary" type="button" @click="$emit('accept')">Add {{ cfg.prof }} &amp; continue</button>
      </div>
    </div>
  </div>
</template>

<script>
// Report → matching Profile cross-sell. Always one-click: the report already
// collected everything the profile needs. Financial/Valuation/Company → IFP;
// Market → IMP.
import { SALES_BY_ID } from './model';

export const REPORT_UPSELL = {
  financial: { prof: 'IFP', name: 'Industry Financial Profile', blurb: 'the standalone industry benchmark set — income statement, balance sheet & 36 ratios, without your inputs', icon: 'account_balance_wallet' },
  valuation: { prof: 'IFP', name: 'Industry Financial Profile', blurb: 'the underlying financial benchmarks — margins, ratios & trends behind the valuation', icon: 'account_balance_wallet' },
  company: { prof: 'IFP', name: 'Industry Financial Profile', blurb: 'the full industry financial benchmark set this company was scored against', icon: 'account_balance_wallet' },
  market: { prof: 'IMP', name: 'Industry Market Profile', blurb: 'market volume, competitor counts & demographics for this selection', icon: 'insights' },
};

export default {
  name: 'report-upsell-modal',
  props: {
    kind: { type: String, required: true },
    industry: { type: Object, required: true },
    area: { type: Object, required: true },
    sc: { type: String, default: null },
    structure: { type: String, default: 'industry_firms' },
    timeline: { type: String, default: '5yr' },
  },
  computed: {
    cfg() {
      return REPORT_UPSELL[this.kind];
    },
    toIFP() {
      return this.cfg.prof === 'IFP';
    },
    scLabel() {
      return this.sc && SALES_BY_ID[this.sc] ? SALES_BY_ID[this.sc].label : '';
    },
  },
};
</script>
